"use client"

import { format, parseISO } from "date-fns"
import type { Event } from "openapi/api/model"
import type { CalendarEventFormDataV2 } from "@/types/calendar"

type EventWithCandidate = Event & {
  candidate_id?: string | null
}

const toLocalTime = (value?: string) => {
  if (!value) return "09:00"
  return format(parseISO(value), "HH:mm")
}

export const createCalendarEventFormDefaults = (
  overrides: Partial<CalendarEventFormDataV2> = {},
): CalendarEventFormDataV2 => ({
  title: "",
  event_type: "interview",
  date: new Date(),
  start_time: "09:00",
  end_time: "10:00",
  location: "",
  notes: "",
  linkType: "job",
  job_id: "",
  candidate_id: "",
  send_invites: true,
  invitee_emails: [],
  include_invite_message: false,
  invite_message: "",
  attachments: [],
  existing_attachments: [],
  remove_attachment_ids: [],
  ...overrides,
})

export const mapEventToCalendarEventFormDefaults = (
  event: Event,
  fallbackCandidateId?: string,
): CalendarEventFormDataV2 => {
  const candidateId = (event as EventWithCandidate).candidate_id ?? fallbackCandidateId ?? ""

  return createCalendarEventFormDefaults({
    title: event.title ?? "",
    event_type: (event.event_type as CalendarEventFormDataV2["event_type"]) ?? "interview",
    date: event.start_at ? parseISO(event.start_at) : new Date(),
    start_time: toLocalTime(event.start_at),
    end_time: toLocalTime(event.end_at),
    location: event.location ?? "",
    notes: event.notes ?? "",
    linkType: candidateId ? "candidate" : "job",
    job_id: event.job_id ?? "",
    candidate_id: candidateId,
    invitee_emails:
      event.invitee_emails
      ?? event.provider_meeting_metadata?.attendees
        ?.map((attendee) => attendee.email?.trim())
        .filter((email): email is string => Boolean(email))
      ?? [],
    existing_attachments: event.provider_meeting_metadata?.attachments ?? [],
  })
}
